import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://roue-des-emotions-reaktor.spmerchflow.com:8001/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Pour FormData, laisser Axios définir le Content-Type avec le boundary correct
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    // Pour la route de login OAuth2, utiliser form-urlencoded
    else if (config.url === '/auth/login' && config.data instanceof URLSearchParams) {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('user_info');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
